import { getAmplitudeInstance } from '../amplitudeHelpers';

type logCellCoverageCalloutTappedParams = {
  trail_id: number;
};

/**
 * Cell coverage callout was tapped by the user
 * @param params - Attributes to log with the amplitude event
 * @param params.trail_id - Trail Id being viewed
 */
const logCellCoverageCalloutTapped = ({ trail_id }: logCellCoverageCalloutTappedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('cell coverage callout tapped', { 'trail id': trail_id }, callback);
};

export default logCellCoverageCalloutTapped;
